export default {
  // report
  REPORT: {
    chapter: {
      ___appendix: 'Appendix',
      title: {
        ___subject: 'Patient Information',
        ___intractable_disease: 'D006-4 指定難病の遺伝学的検査',
        ___disease_diagnosis: 'Candidate List',
        ___active_screening: 'Proactive Test',
        ___cause_screening: 'Carrier Screening',
        ___acmg_incidental: 'ACMG Incidental',
        ___custom1: 'custom1',
        ___custom2: 'custom2',
        ___custom3: 'custom3',
        ___constitution: 'Constitution-related genes',
        ___drug_meta: 'Pharmacogenetics',
        ___method: 'Method',
        ___appendix_intractable_disease_list: 'D006_4 遺傳子リスト',
        ___appendix_disease_gene: 'Candidate Gene List',
        ___appendix_us_gene: 'ACMG Guideline'
      },
      item: {
        title: {
          ___resultSummary: 'Result Summary',
          ___interpretation: 'Interpretation'
        }
      },
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊The report has to be interpreted by medical professionals.',
        ___info02: '17F.-10, No. 118, Ciyun Rd., Hsinchu City 300 , Taiwan (R.O.C.) | Compass Bioinformatics Inc. | 886-3-574-5009',
        ___infoAct01: 'ACT Genomics laboratory is accredited by CAP. CAP number: 9028096.',
        ___infoAct02: 'ACT Genomics only provides a technical report of the test, please consult a specialist physician to determine the appropriate clinical solution and follow the instruction of the physician. The results are only valid for the tested sample(s).',
        ___infoAct03: 'ACT Genomics Laboratory HQ: 3F, No. 345, Xinhu 2nd Rd, Taipei, Taiwan 11494',
        ___infoAct04: 'Email:service@actgenomics.com T: +886-2-2795-3660 F: +886-2-2795-5016'
      },
      basicInfo: {
        ___title: 'Patient Information',
        ___signTitle: '署名',
        form: {
          title: {
            ___case_id: 'Name',
            ___sex: 'Sex',
            ___age: 'Age',
            ___testing_date: 'Test Date',
            ___testing_category: 'Sample\ntype',
            ___sequencing_range: 'Test',
            ___sequencing_tech: 'Seqencing \nPlatform',
            ___doctor_name: 'Doctor',
            ___organization: 'Hospital',
            ___medical_number: 'Clinical\nID',
            ___family_medical_history: 'Note'
          }
        }
      },
      variantResult: {
        mainData: {
          default: {
            ___title: 'Interpretation',
            ___contentTitle01_01: 'We detected <b>{count}</b> gene with likely disease-causing variants | We detected <b>{count}</b> genes with likely disease-causing variants',
            ___contentTitle01_02: 'We detected <b>{count}</b> gene with likely disease-causing variants.  | We detected <b>{count}</b> genes with likely disease-causing variants. ',
            ___contentTitle02: 'there is {count} <b>gene located in the mitochondria. | there are<b> {count} <b>genes located in the mitochondria.',
            detail: {
              title: {
                ___ClinVar: 'The clinical interpretation of ClinVar is {result}',
                ___ClinVar_empty: 'ClinVar data is not available',
                ___ACMG: 'The classification of ACMG is {result}',
                ___OMIM: 'There are associated-diseases were found in OMIM, which are:',
                ___OMIM_empty: 'No gene associated-diseases were found in OMIM',
                ___Orphanet: 'There are associated-diseases were found in Orphanet, which are:',
                ___Orphanet_empty: 'No gene associated-diseases were found in Orphanet'
              }
            }
          },
          sv: {
            ___title: 'SV Interpretation',
            ___contentTitle01: 'We detected <b>{count}</b> gene with likely disease-causing variants | We detected <b>{count}</b> genes with likely disease-causing variants',
            detail: {
              title: {
                ___genes: 'Affected genes within this region are {result}',
                ___OMIM: 'There are associated-diseases were found in OMIM, which are:',
                ___OMIM_empty: 'No gene associated-diseases were found in OMIM'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: 'Result Summary',
        ___variantContainerTitle: 'Related Diseases and Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___variantNotePlaceholder: 'Note',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar Database',
            ___ACMG: 'ACMG Guideline',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___AF_EN: 'GnomAD Exomes AF / GnomAD Genomes AF',
            ___AF_JP: 'GnomAD Genomes AF / ToMMo 60K JPN',
            ___Population_Databases: 'Population Databases',
            ___Prediction_Score: 'Prediction Score',
            ___Sequencing_Quality: 'Sequencing Quality'
          }
        },
        info: {
          title: {
            ___phenotypes: 'Phenotype',
            ___gene_panels: 'Gene Panels',
            ___related_genes: 'Gene'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: 'Position<br>(HG38)',
            ___custom_details_Rank: 'Exon/Intron',
            ___custom_details_HGVSm: 'HGVSm',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT_AF: 'Heteroplasmy<br>Level (%)',
            ___custom_details_GT: 'Zygosity',
            ___custom_details_Consequence: 'Consequence',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: 'Parental<br>Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_AF: 'GnomAD Exomes',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: 'TW Biobank',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___tommo_60kjpn_AF: 'ToMMo 60K JPN',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_noAF: 'BayesDel noAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantSV: {
        ___mainTableTitle: 'SV Result Summary',
        ___symbolContainerTitle: 'Related Gene',
        ___geneContainerTitle: 'Related Diseases ana Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___svNotePlaceholder: 'Note',
        svTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'Exon/Intron',
            ___Zygosity: 'Zygosity',
            ___Consequence: 'Consequence',
            ___Fragment_size: 'Fragment size',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'SV Result Summary',
        ___symbolContainerTitle: 'Related Gene',
        ___geneContainerTitle: 'Related Diseases ana Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___cnvNotePlaceholder: 'Note',
        cnvTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'Exon/Intron',
            ___Zygosity: 'Zygosity',
            ___Consequence: 'Consequence',
            ___Fragment_size: 'Fragment size',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        }
      },
      intractableDiseaseResult: {
        ___title: 'D006-4 指定難病の遺伝学的検査',
        diseaseList: {
          ___title: '指定難病'
        },
        diseaseRange: {
          ___title: '遺伝子の範囲',
          content: {
            ___list: '<b>{name}</b>に関連する遺伝子を対象として、{count}個の遺伝子に対する関連性解析をすでに実施しております。',
            ___suffix: '詳細は別添の「D006-4 遺伝子リスト」をご参照ください。'
          }
        }
      },
      constitutionGene: {
        ___title: 'Constitution-related genes',
        ___subTitle: 'Many genes have been found to be associated with allergies, blood clots, and alcohol intolerance. This important information provides lifestyle precautions for you.',
        mainData: {
          testSummary: {
            ___title: 'Test summary'
          }
        },
        mainTable: {
          testingItems: {
            ___title: 'Detailed testing items'
          }
        },
        table: {
          title: {
            ___title: 'Items',
            ___SYMBOL: 'Gene',
            ___Location2: 'Position',
            ___Result: 'Results'
          },
          value: {
            Result: {
              ___true: 'Positive',
              ___false: 'Negative'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: 'Pharmacogenetics',
        ___subTitle: 'Pharmacogenetics provides doctors with references to choose the most suitable medication for individuals, preventing severe side effects and toxicity, and achieving the optimal treatment response. In the case of the same medication, some individuals may experience severe allergies or heightened side effects, which can be attributed to using medication or dosages that are not suitable for them.',
        customInfos: {
          ___info01: '＊ The genotype marked in red indicates the detected risk genotype.'
        },
        mainData: {
          testSummary: {
            ___title: 'Test summary'
          }
        },
        mainTable: {
          testingItems: {
            ___title: 'Detailed testing items'
          }
        },
        table: {
          title: {
            ___name: 'Chemicals',
            ___type: 'Type',
            ___SYMBOL: 'Gene',
            ___risk_genotype2: 'Position',
            ___clinical_phenotype: 'Clinical phenotype',
            ___Result: 'Results'
          },
          value: {
            Result: {
              ___true: 'Positive',
              ___false: 'Negative'
            }
          }
        }
      },
      detectMethod: {
        ___title: 'Test method/quality and analysis software versions',
        ___subTitle: 'Description of testing method',
        option: {
          title: {
            ___metrics: 'Upload Metrics'
          }
        },
        table: {
          title: {
            ___library_kit: 'Library preparation kit',
            ___sequencing_platform: 'Sequencing platform',
            ___sequencing_length: 'Sequencing length',
            ___average_sequencing_length: 'Sequencing throughput',
            ___pct_target_bases_xx: '10/20X coverage of target region',
            ___reference: 'Reference genome',
            ___alignment_version: 'Alignment software',
            ___variant_calling_version: 'Variant calling software',
            ___jannovar_version: 'Variant annotation software jANNOVAR',
            ___vep_version: 'Variant annotation software VEP',
            ___hpo_version: 'HPO version',
            ___omim_version: 'OMIM version',
            ___dbsnp_version: 'dbSNP version',
            ___clinvar_version: 'ClinVar version',
            ___mitomap_version: 'MITOMAP version',
            ___dbnsfp_version: 'dbNSFP version'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: 'Terminologies',
        list: {
          list01: {
            ___title: 'The reference genome used for this examination is GRCh38 (or hg38)'
          },
          list02: {
            ___title: '<b>Genotype</b>',
            detail: {
              detail01: {
                ___title: 'Homozygous: A homozygous genotype may include two normal alleles or two alleles that have the same variant.'
              },
              detail02: {
                ___title: 'Heterozygous: A heterozygous genotype may include one normal allele and one mutated allele or two different mutated alleles (compound heterozygote).'
              },
              detail03: {
                ___title: 'Hemizygous: A term that describes a person who has only one copy of a gene rather than the usual two copies. Hemizygosity can occur under normal conditions. For example, because most males have one X chromosome and one Y chromosome, they are hemizygous for genes on those chromosomes.'
              }
            }
          },
          list03: {
            ___title: '<b>Clinical significance</b>: Refer to ClinVar database interpretation or ACMG (2015) classification.',
            detail: {
              detail01: {
                ___title: 'Pathogenic: The variant of a given gene is pathogenic.'
              },
              detail02: {
                ___title: 'Likely pathogenic: The variant of a given gene is likely to be pathogenic.'
              },
              detail03: {
                ___title: 'Uncertain significance: The variant of a given gene is uncertain significance'
              },
              detail04: {
                ___title: 'Likely benign: The variant of a given gene is likely to be benign.'
              },
              detail05: {
                ___title: 'Benign： The variant of a given gene is benign.'
              },
              detail06: {
                ___title: 'Conflicting interpretations of pathogenicity:Only for submissions from a consortium, where groups within the consortium have conflicting interpretations of a variant but provide a single submission to ClinVar.'
              },
              detail07: {
                ___title: 'Disease-associated polymorphism: It has been reported that polymorphism in a particular gene is associated with the disease.'
              },
              detail08: {
                ___title: 'SNP:The allele frequency of the variant is greater than 1% in 1000 Genomes, and no related diseases have been reported.'
              },
              detail09: {
                ___title: 'Drug response: A general term for a variant that affects a drug response, not a disease.'
              }
            }
          },
          list04: {
            ___title: '<b>Refereces</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS: The allele frequency from the East Asian population of the 1000 Genomes project.'
              },
              detail02: {
                ___title: 'gnomAD EAS: The allele frequency from the East Asian population of the gnomAD project.'
              },
              detail03: {
                ___title: 'Taiwan BioBank: The allele frequency from Taiwan BioBank'
              },
              detail04: {
                ___title: 'References：If this variant has been reported in literature, the reference will list the first author, publication year, journal name, volume number, and starting page.'
              },
              detail05: {
                ___title: 'SIFT and PolyPhen-2 are two tools used to predict the clinical impact of amino acid variations. In SIFT, the prediction result is labeled as "damaging" or "tolerated", with the number in parentheses being the predicted result. In PolyPhen-2, the prediction result is labeled as "damaging", "possibly damaging", or "benign", with the number in parentheses being the predicted result. However, this prediction result lacks relevant evidence for protein or genomic research, and the accuracy of its predicted clinical significance cannot be confirmed, and is for reference only.'
              }
            }
          }
        }
      },
      attachmentIntractableDiseaseDetail: {
        ___title: 'D006_4 遺傳子リスト',
        table: {
          title: {
            ___disease: 'D006-4 遺伝学的検査の疾患名',
            ___gene: '代表的な疾患原因遺伝子<br>(指定難病の診断基準の遺伝子)'
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: 'Candidate Gene List',
        ___geneListTitle01: 'The coverage of genes ≥ {cov}',
        ___geneListTitle02: 'The coverage of genes < {cov}'
      },
      attachmentASoHGGene: {
        ___title: 'ACMG Guideline'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/_report/en/lang.js